__turbopack_context__.v({
  "bars": "nav-module__c35mlW__bars",
  "close": "nav-module__c35mlW__close",
  "logo": "nav-module__c35mlW__logo",
  "menu": "nav-module__c35mlW__menu",
  "mobile-menu": "nav-module__c35mlW__mobile-menu",
  "mobile-menu-header": "nav-module__c35mlW__mobile-menu-header",
  "mobile-menu-links": "nav-module__c35mlW__mobile-menu-links",
  "nav": "nav-module__c35mlW__nav",
  "nav-wrapper": "nav-module__c35mlW__nav-wrapper",
  "open": "nav-module__c35mlW__open",
  "overlay": "nav-module__c35mlW__overlay",
  "right-nav": "nav-module__c35mlW__right-nav",
  "scrolled": "nav-module__c35mlW__scrolled",
});
